export default {"theme":{"themes":{"options":{"customProperties":true},"light":{"primary":"#A5A5A5"},"dark":{"primary":"#A5A5A5"}}}}
